// extracted by mini-css-extract-plugin
export default {"pill":"qK4yi22SmA1WMTa1NdzJ","label":"MU9Xvn0xnmnrJKaQThln"};